// extracted by mini-css-extract-plugin
module.exports = {"container":"AttivitaItem_container__3r9Ld","expanded":"AttivitaItem_expanded__2Jbt6"};